import { Pencil1Icon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import React, { FC } from 'react'
import styled from 'styled-components'

const StyledPencilIcon = styled(Pencil1Icon)`
  color: lightgray;
  &:hover {
    color: white;
  }
`

export const EditMeasurementButton: FC<{
  onClick: (e: React.MouseEvent) => void
}> = ({ onClick }) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation()
    onClick(e)
  }

  return (
    <TooltipWrapper side={'top'} label={'Edit measurement'}>
      <div
        style={{ cursor: 'pointer', marginLeft: '-4px' }}
        onClick={handleClick}
        data-action-button='true'>
        <StyledPencilIcon width={20} height={20} />
      </div>
    </TooltipWrapper>
  )
}
